import { render, staticRenderFns } from "./PartnerUsers.vue?vue&type=template&id=33ef45c9&scoped=true"
import script from "./PartnerUsers.vue?vue&type=script&lang=js"
export * from "./PartnerUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef45c9",
  null
  
)

export default component.exports